var ClosestDivision, Geocoder, Location, SearchBar, SearchBarView, base, base1, base2, setTranslations;

SearchBarView = require('./views/search_bar');

Location = require('../../../../../src/frontend/helper/search/helper/m_location_helper');

ClosestDivision = require('../../../../../src/frontend/helper/search/common/m_closest_division');

setTranslations = require('../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee').setTranslations;

Geocoder = require('../../../../../src/frontend/helper/search/common/m_geocoder');

module.exports = SearchBar = {
  Autocomplete: {},
  init: function(options) {
    var $searchBar;
    SearchBar.GOOGLE_GEO_URL = options.google_geo_url;
    Location.setDivision(options.division);
    setTranslations(Groupon.LS.translations);
    if (($searchBar = $('form#search-bar, form#ls-search-form')).length) {
      return new SearchBarView({
        $el: $searchBar
      });
    }
  }
};

$(function() {
  var searchConfig;
  if ((searchConfig = Groupon.Modules.SearchBar.Config)) {
    return Groupon.Modules.SearchBar.init(searchConfig);
  }
});

if ((base = window.Groupon).Utils == null) {
  base.Utils = {};
}

_.extend(Groupon.Utils, {
  ClosestDivision: ClosestDivision,
  Geocoder: Geocoder
});

if ((base1 = window.Groupon).Modules == null) {
  base1.Modules = {};
}

if ((base2 = window.Groupon.Modules).SearchBar == null) {
  base2.SearchBar = {};
}

_.extend(window.Groupon.Modules.SearchBar, SearchBar);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL21vZHVsZXMvZ2lnX2JvZHkvaGVhZGVyL3NlYXJjaF9iYXIvZnJvbnRlbmQvaW5kZXguY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL21vZHVsZXMvZ2lnX2JvZHkvaGVhZGVyL3NlYXJjaF9iYXIvZnJvbnRlbmQvaW5kZXguY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsYUFBQSxHQUFnQixPQUFBLENBQVEsb0JBQVI7O0FBQ2hCLFFBQUEsR0FBVyxPQUFBLENBQVEsb0VBQVI7O0FBQ1gsZUFBQSxHQUFrQixPQUFBLENBQVEscUVBQVI7O0FBQ2pCLGtCQUFtQixPQUFBLENBQVEsNEVBQVI7O0FBQ3BCLFFBQUEsR0FBVyxPQUFBLENBQVEsNkRBQVI7O0FBR1gsTUFBTSxDQUFDLE9BQVAsR0FBaUIsU0FBQSxHQUFZO0VBQzNCLFlBQUEsRUFBYyxFQURhO0VBRzNCLElBQUEsRUFBTSxTQUFDLE9BQUQ7QUFDSixRQUFBO0lBQUEsU0FBUyxDQUFDLGNBQVYsR0FBMkIsT0FBTyxDQUFDO0lBQ25DLFFBQVEsQ0FBQyxXQUFULENBQXFCLE9BQU8sQ0FBQyxRQUE3QjtJQUNBLGVBQUEsQ0FBZ0IsT0FBTyxDQUFDLEVBQUUsQ0FBQyxZQUEzQjtJQUVBLElBQUcsQ0FBQyxVQUFBLEdBQWEsQ0FBQSxDQUFFLHNDQUFGLENBQWQsQ0FBd0QsQ0FBQyxNQUE1RDthQUNNLElBQUEsYUFBQSxDQUFjO1FBQ2hCLEdBQUEsRUFBSyxVQURXO09BQWQsRUFETjs7RUFMSSxDQUhxQjs7O0FBYzdCLENBQUEsQ0FBRSxTQUFBO0FBQ0EsTUFBQTtFQUFBLElBQUcsQ0FBQyxZQUFBLEdBQWUsT0FBTyxDQUFDLE9BQU8sQ0FBQyxTQUFTLENBQUMsTUFBMUMsQ0FBSDtXQUNFLE9BQU8sQ0FBQyxPQUFPLENBQUMsU0FBUyxDQUFDLElBQTFCLENBQStCLFlBQS9CLEVBREY7O0FBREEsQ0FBRjs7O01BSWMsQ0FBQyxRQUFTOzs7QUFDeEIsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxPQUFPLENBQUMsS0FBakIsRUFBd0I7RUFDdEIsaUJBQUEsZUFEc0I7RUFFdEIsVUFBQSxRQUZzQjtDQUF4Qjs7O09BS2MsQ0FBQyxVQUFXOzs7O09BQ0osQ0FBQyxZQUFhOzs7QUFDcEMsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxNQUFNLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxTQUFoQyxFQUEyQyxTQUEzQyJ9
